import { FilterSwitch } from '@fagmobler/ui';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import {
  useRefinementList,
  UseRefinementListProps,
} from 'react-instantsearch-hooks-web';

export type TagsFilterProps = {
  getText?: (item: RefinementListItem) => string;
};

export const TagsFilter = (props: UseRefinementListProps & TagsFilterProps) => {
  const { getText, ...rest } = props;
  const { items, refine, canRefine } = useRefinementList(rest);

  return (
    <div className="space-y-4">
      {items
        .filter((item) => item.value !== 'Medlemstilbud')
        .map((item) => {
          return (
            <FilterSwitch
              classNames={{ title: 'capitalize' }}
              key={item.label}
              title={item.label}
              onChange={() => refine(item.value)}
              checked={item.isRefined}
              disabled={!canRefine}
            >
              {getText ? getText(item) : null}
            </FilterSwitch>
          );
        })}
    </div>
  );
};

export default TagsFilter;
